import {
  APPEND_PARTNER_RECURRING_SUCCESS,
  PARTNER_RECURRING_FAILED,
  PARTNER_RECURRING_LOADING,
  PARTNER_RECURRING_REMOVE,
  PARTNER_RECURRING_SUCCESS,
  RESET_PARTNER_RECURRING_LIST,
} from "../types";

interface PartnerResponse {
  content?: any[];
  last?: boolean;
  [key: string]: any;
}

const initialState: {
  loading: boolean;
  error: any;
  status: any;
  partner: PartnerResponse | null;
  request: any;
} = {
  loading: false,
  error: null,
  status: null,
  partner: null,
  request: null,
};

export const partnerAssignReducer = (
  state = initialState,
  action: {
    type: any;
    loading: any;
    payload: any;
    status: any;
    error: any;
    request: any;
  }
) => {
  switch (action.type) {
    case PARTNER_RECURRING_LOADING:
      return {
        ...state,
        loading: true,
      };
    case PARTNER_RECURRING_SUCCESS:
      return {
        ...state,
        loading: false,
        partner: action.payload,
        status: action.status,
        error: null,
        request: action.request,
      };
    case APPEND_PARTNER_RECURRING_SUCCESS: {
      const existingContent = state.partner?.content ?? [];
      return {
        ...state,
        loading: false,
        partner: {
          ...action.payload,
          content: [...existingContent, ...(action.payload?.content ?? [])],
        },
        status: action.status,
        error: null,
        request: action.request,
      };
    }
    case RESET_PARTNER_RECURRING_LIST:
      return {
        ...initialState,
      };
    case PARTNER_RECURRING_FAILED:
      return {
        ...state,
        loading: false,
        status: action.status,
        error: action.error,
        request: action.request,
      };
    case PARTNER_RECURRING_REMOVE:
      return initialState;

    default:
      return state;
  }
};
